<script>
import Component from '~/sites/shop/pages/branch/_slug'
export default {
  extends: Component,
  nuxtI18n: {
    paths: {
      cs: '/pobocky/:slug',
      de: '/niederlassung/:slug',
      en: '/branches/:slug',
      sk: '/pobocky/:slug',
    },
  },
}
</script>
